/** Dual-entry agent product (matches JWT / session.product). */
export type AiAgentProduct = "giada" | "waine";

export function normalizeAiAgentProduct(
  raw: string | null | undefined
): AiAgentProduct {
  return raw && String(raw).trim().toLowerCase() === "giada" ? "giada" : "waine";
}
